import React, {useState, useEffect} from 'react';
import { IQuestionEditorState, TypeQuestionsCategoriesEditor } from 'app_components/modules/academicComponentEditor/containers/academicComponentEditorFunctions';
import EditorPanelExerciseEditorComponent from '../editorPanelExerciseEditor/containers/editorPanelExerciseEditorComponent';
import { DragDropContext, Draggable, Droppable } from 'react-beautiful-dnd';
import OutlineContainerDrag from '../outlineContainerDrag/outlineContainerDrag';
import { useTranslation } from 'react-i18next';
import { useColors } from 'app_hooks/useColors';
import CatalogerService from 'app_services/editor/cataloger/catalogerService';
import QuestionsService from 'app_services/editor/questions/questionsService';
import ModalNewQuestionComponent from '../modalNewQuestion/containers/modalNewQuestionComponent';

import './editorPanelStimulus.scss'

const CHARACTERIZATION_SURVEY_QUESTION_TYPES: TypeQuestionsCategoriesEditor[] = [
  'multiple-choice-multiple-answer',
  'multiple-choice-unique-answer'
]
const NORMAL_SURVEY_QUESTION_TYPES: TypeQuestionsCategoriesEditor[] = [
  'multiple-choice-unique-answer',
  'open-answer',
  'select-range'
]

export interface EditorPanelStimulusProps {
  question: IQuestionEditorState
  childs: IQuestionEditorState[]
  currentQuestion: IQuestionEditorState
  disableAll?: boolean
  hideEditButton?: boolean
  showDeleteButton?: boolean
  isCharacterizationSurvey?: boolean
  onClickSave?: (resp: IQuestionEditorState, id?: string) => void
  onClickDelete?: (question?: IQuestionEditorState) => void
  onClickFinish?: ()=>void
  onQuestionSaved?: (status?: boolean, newQuestion?: IQuestionEditorState) => void
  onQuestionDeleted?: (status?: boolean, id?: string) => void
  onNewQuestion?: (data?: any)=>void
  onReorderFinish?: (question?: IQuestionEditorState)=>void
  onChangeCurrentQuestion?: (question: IQuestionEditorState) => any
}

const EditorPanelStimulus: React.SFC<EditorPanelStimulusProps> = (props) => {

  const [currentQuestion, updateCurrentQuestion] = useState<IQuestionEditorState | undefined>(undefined)
  const [question, updateQuestion] = useState<IQuestionEditorState | undefined>(undefined)
  // const [childs, updateChilds] = useState<IQuestionEditorState[]>(props.childs)

  const {t} = useTranslation()
  const [colors] = useColors()

  // Servicios
  const questionsService = new QuestionsService()

  useEffect(() => {
    if(props.currentQuestion){
      updateCurrentQuestion({...props.currentQuestion})
    }
  }, [props.currentQuestion])

  useEffect(() => {
    if(props.question){
      updateQuestion({...props.question})
    }
  }, [props.question])

  // useEffect(() => {
  //   // if(props.childs){
  //     updateChilds([...props.childs])
  //   // }
  // }, [props.childs])


  // Servicios
  const catalogerService = new CatalogerService()

  /**
   * @INFO Referencia de cuando se guarda alguna pregunta
   * @param status
   * @param id
   */
  const handleQuestionSaved = (status?: boolean, newQuestion?: IQuestionEditorState) => {
    if(props.onQuestionSaved){
      props.onQuestionSaved(status, newQuestion)
    }
  }

  /**
   * @INFO Eliminar una pregunta del ejercicio
   * @param question
   */
  const handleClickDelete = (question?: IQuestionEditorState) => {
    if(props.onClickDelete){
      props.onClickDelete(question)
      sendChangeModified(false)
    }
  }

  /**
   * @INFO Enviar el método cuando una de las preguntas tiene un cambio en su contenido
   * @param question
   */
  const handleChangeQuestion = (question?: IQuestionEditorState) => {
    if(!questionsService.hasAnyChange()){
      questionsService.updateStatusChanged(true)
    }
  }

  /**
   * @INFO Reordenar hijos de un estimulo
   * @param result
   */
  const handleReorderQuestions = async (result: any) => {
    if(!result.destination || !question) return
    const status = await questionsService.validateChangeQuestion()
    if(!status) return
    const questionAux = {...question}
    const startIndex = result.source.index
    const endIndex = result.destination.index
    if(questionAux.childs){
      // @ts-ignore
      const [removed] = questionAux.childs?.splice(startIndex, 1)
      questionAux.childs?.splice(endIndex, 0, removed)
      console.log('Questions aux: ', questionAux);
      if(props.onReorderFinish){
          props.onReorderFinish(questionAux)
          sendOnChangeCurrentQuestionEvent(undefined)
      }
    }
  }

  /**
   * @INFO Click en editar otro child o pregunta
   * @param question
   */
  const handleClickEditQuestion = async (question?: IQuestionEditorState) => {
    if(!question) return
    const status = await questionsService.validateChangeQuestion()
    if(status){
      sendOnChangeCurrentQuestionEvent({...question})
    }
  }

  /**
   * @INFO Enviar el cambio de pregunta modificada
   * @param state
   */
  const sendChangeModified = (state: boolean) => {
    questionsService.updateStatusChanged(state)
  }

  /**
   * @INFO Enviar la nueva current question
   * @param question
   */
  const sendOnChangeCurrentQuestionEvent = (question?: IQuestionEditorState) => {
    if(props.onChangeCurrentQuestion && question){
      props.onChangeCurrentQuestion({...question})
    }
  }

  /**
   * @INFO Obtener el estado de edición de la pregunta,
   * depende de la current question que se esta editando
   * @param question
   * @returns
   */
  const getEditStateQuestion = (question?: IQuestionEditorState) => {
    if(!question) return false
    if(currentQuestion){
      if(currentQuestion?.question?._id === question?.question?._id){
        return true
      }else{
        return false
      }
    }else{
      return false
    }
  }

  /**
   * @INFO Enviar la pregunta creada a componente principal
   * @param data
   */
  const handleCloseModal = (data: any) => {
    if(props.onNewQuestion){
      props.onNewQuestion(data)
    }
  }

  return (
    <div className="editor_panel_stimulus-layout">
      {question ?
        <>
          <EditorPanelExerciseEditorComponent
            editState={ props.disableAll ? !props.disableAll : getEditStateQuestion(question)}
            question={question}
            onQuestionSaved={(status) => handleQuestionSaved(status, {...question})}
            onChangeQuestion={(question) => handleChangeQuestion(question)}
            onClickEdit={handleClickEditQuestion}
            onClickDelete={handleClickDelete}
            hideAddButton
            hideViewButton
            hideEditButton={props.hideEditButton}
            showDeleteButton={props.showDeleteButton}
            onClickFinish={props.onClickFinish}
          >
            <DragDropContext
              onDragEnd={handleReorderQuestions}
            >
              <Droppable
                droppableId={question.question._id}
              >
                {(provided, snapshot) => (
                  <div
                    {...provided.droppableProps}
                    ref={provided.innerRef}
                  >
                    {props.childs.map((itemChild, idxChild) => (
                      <Draggable
                        draggableId={itemChild.question._id}
                        key={itemChild.question._id}
                        index={idxChild}
                      >
                        {(provided2, snapshot2) => (
                          <div
                            ref={provided2.innerRef}
                            {...provided2.draggableProps}
                            id={itemChild.question._id}
                          >
                            <OutlineContainerDrag
                              title={`${t('editor.resources.exercise.question')} ${idxChild+1} ${t('editor.resources.exercise.of_this_stimulus')}`}
                              provided={provided2}
                            >
                              <EditorPanelExerciseEditorComponent
                                question={itemChild}
                                editState={ props.disableAll ? !props.disableAll : getEditStateQuestion(itemChild)}
                                hideAddButton
                                hideTitle
                                hideFinishButton
                                hideEditButton={props.hideEditButton}
                                showDeleteButton={props.showDeleteButton}
                                style={{border: 'none', padding: '0px'}}
                                onClickEdit={handleClickEditQuestion}
                                onQuestionSaved={(status) => handleQuestionSaved(status, {...itemChild})}
                                onChangeQuestion={(question) => handleChangeQuestion(question)}
                                onClickDelete={handleClickDelete}
                                isCharacterizationSurvey={props.isCharacterizationSurvey}
                                // onClickView={(itemView) => catalogerService.previewQuestion(itemView?.question?._id)}
                              />
                            </OutlineContainerDrag>
                          </div>
                        )}
                      </Draggable>
                    ))}
                    {provided.placeholder}
                  </div>
                )}
              </Droppable>
            </DragDropContext>
            {!props.disableAll ?
              <OutlineContainerDrag
                title={t('editor.resources.exercise.add_question_to_stimulus')}
                style={{display: 'flex', justifyContent: 'center'}}
              >
                <ModalNewQuestionComponent
                  open={true}
                  handleClose={handleCloseModal}
                  disableModal
                  createWithClick
                  inputData={{
                    parent: question.question._id
                  }}
                  className='options-new-question'
                  only={props.isCharacterizationSurvey ? CHARACTERIZATION_SURVEY_QUESTION_TYPES : NORMAL_SURVEY_QUESTION_TYPES}
                />
              </OutlineContainerDrag>
            :null}
          </EditorPanelExerciseEditorComponent>
        </>
      : null}
    </div>
  );
}

export default EditorPanelStimulus;
